var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCassiopeiaBadgeEmail = function SvgCassiopeiaBadgeEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 50,
    viewBox: "0 0 9.525 13.229",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M208.824 191.182H102.082c-15.844 0-28.7 12.856-28.7 28.7v356.71c0 15.844 12.856 28.7 28.7 28.7h523.632c15.844 0 28.7-12.856 28.7-28.7v-356.71c0-15.844-12.856-28.7-28.7-28.7z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e74138",
    d: "M654.832 354.421h-47.395a1.691 1.691 0 0 1-1.668-1.668v-29.882c0-.903.765-1.668 1.668-1.668h47.395c.903 0 1.667.765 1.667 1.668v29.882c0 .973-.764 1.668-1.667 1.668z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3474b9",
    d: "M654.832 406.82h-47.395a1.691 1.691 0 0 1-1.668-1.669V375.27c0-.903.765-1.668 1.668-1.668h47.395c.903 0 1.667.765 1.667 1.668v29.882c0 .904-.764 1.668-1.667 1.668z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e74138",
    d: "M654.832 459.217h-47.395a1.691 1.691 0 0 1-1.668-1.668v-29.882c0-.903.765-1.668 1.668-1.668h47.395c.903 0 1.667.765 1.667 1.668v29.882c0 .904-.764 1.668-1.667 1.668zM125.988 354.421H78.594a1.691 1.691 0 0 1-1.668-1.668v-29.882c0-.903.764-1.668 1.668-1.668h47.394c.903 0 1.668.765 1.668 1.668v29.882c-.07.973-.765 1.668-1.668 1.668z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3474b9",
    d: "M125.988 406.82H78.594a1.691 1.691 0 0 1-1.668-1.669V375.27c0-.903.764-1.668 1.668-1.668h47.394c.903 0 1.668.765 1.668 1.668v29.882c-.07.904-.765 1.668-1.668 1.668z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e74138",
    d: "M125.988 459.217H78.594a1.691 1.691 0 0 1-1.668-1.668v-29.882c0-.903.764-1.668 1.668-1.668h47.394c.903 0 1.668.765 1.668 1.668v29.882c-.07.904-.765 1.668-1.668 1.668z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M626.548 211.057c8.686-6.185 4.308-19.945-6.394-19.945H107.711c-10.702 0-15.08 13.69-6.393 19.945l230.787 164.49c19.041 13.551 44.545 13.551 63.517 0z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e3a39",
    d: "M363.933 393.06c-12.995 0-25.435-3.962-35.998-11.536L97.148 217.034c-6.602-4.726-9.312-12.788-6.81-20.501 2.502-7.714 9.312-12.718 17.443-12.718h512.443c8.13 0 14.94 5.004 17.443 12.718 2.501 7.713-.209 15.775-6.81 20.5L399.93 381.523c-10.563 7.575-23.002 11.536-35.997 11.536zM107.71 198.477c-2.432 0-3.196 1.807-3.474 2.502-.278.765-.626 2.71 1.39 4.1l230.786 164.56c8.062 5.768 17.582 8.826 27.52 8.826 9.937 0 19.458-3.058 27.52-8.826l230.786-164.49c1.946-1.39 1.599-3.336 1.39-4.1-.278-.765-1.042-2.502-3.475-2.502H107.711Z",
    style: {
      fill: "#818181",
      fillOpacity: 1,
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e3a39",
    d: "M625.783 614.673h-523.7C81.094 614.673 64 597.578 64 576.591V219.882c0-20.987 17.095-38.082 38.082-38.082h523.632c20.987 0 38.082 17.095 38.082 38.082v356.71c.07 20.986-17.026 38.081-38.013 38.081zm-523.7-414.11c-10.633 0-19.25 8.617-19.25 19.25v356.709c0 10.632 8.617 19.25 19.25 19.25h523.63c10.633 0 19.25-8.618 19.25-19.25v-356.64c0-10.632-8.617-19.25-19.25-19.25h-523.63Z",
    style: {
      fill: "#818181",
      fillOpacity: 1,
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M314.801 385.068a49.48 49.48 0 1 0 98.958 0 49.48 49.48 0 1 0-98.958 0z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e3a39",
    d: "M364.28 441.844c-31.341 0-56.776-25.504-56.776-56.776 0-31.272 25.504-56.776 56.776-56.776 31.272 0 56.776 25.504 56.776 56.776 0 31.272-25.504 56.776-56.776 56.776zm0-98.959c-23.21 0-42.113 18.902-42.113 42.113s18.903 42.113 42.113 42.113c23.211 0 42.113-18.902 42.113-42.113 0-23.21-18.902-42.113-42.113-42.113z",
    style: {
      fill: "#818181",
      fillOpacity: 1,
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e74138",
    d: "M337.039 385.068a27.241 27.241 0 1 0 54.483 0 27.241 27.241 0 1 0-54.483 0z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#336ead",
    d: "M364.28 419.606c-19.04 0-34.538-15.497-34.538-34.538 0-19.041 15.497-34.538 34.538-34.538 19.041 0 34.538 15.497 34.538 34.538 0 19.04-15.497 34.538-34.538 34.538zm0-54.413c-10.98 0-19.875 8.895-19.875 19.875s8.895 19.875 19.875 19.875 19.875-8.895 19.875-19.875-8.964-19.875-19.875-19.875z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9e6e6",
    d: "M482.836 531.49H142.319a2.491 2.491 0 0 1-2.502-2.502v-10.146a2.491 2.491 0 0 1 2.502-2.502h340.517a2.491 2.491 0 0 1 2.502 2.502v10.146a2.491 2.491 0 0 1-2.502 2.502zm-107.854 28.284H142.388a2.491 2.491 0 0 1-2.501-2.502v-10.146a2.491 2.491 0 0 1 2.501-2.502h232.664a2.491 2.491 0 0 1 2.501 2.502v10.146c0 1.39-1.18 2.502-2.57 2.502zm212.58-60.529H142.388a2.491 2.491 0 0 1-2.501-2.502v-10.146a2.491 2.491 0 0 1 2.501-2.501h445.174a2.491 2.491 0 0 1 2.502 2.501v10.146a2.491 2.491 0 0 1-2.502 2.502z",
    style: {
      strokeWidth: 1
    },
    transform: "translate(-1.016 .29) scale(.01588)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCassiopeiaBadgeEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cassiopeia-badge-email.3054ca68c85ab891abf0334da33f00d8.svg";